import {useContext} from "react";

import LoadingScreen from "../LoadingScreen";
import Container from "./Container";
import PLATFORMS from "../../tools/defaults/Platforms";
import Result from "./Result";
import InitConfirm from "./InitConfirm";
import OTP from "./OTP";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";
import CreatePayment from "./CreatePayment";
import {calculateOtpTimer} from "../../tools/helpers";
import WidgetCard from "./WidgetCard";

const OTP_CONFIG = {
    TITLE: "تایید کد اعتبار سنجی",
    DESCRIPTION: "کد اعتبار سنجی برای شما ارسال شده است"
}
const FinCheckContent = () => {
    const finCheckContext = useContext(FinCheckContext);

    if (finCheckContext === null) {
        return null;
    }
    if (finCheckContext.loading && finCheckContext.loading.isLoading) {
        return <LoadingScreen text={finCheckContext.loading.message}/>
    }

    return <>
        {
            <Container className="min-h-screen flex flex-col justify-center ">
            {finCheckContext.widget && <WidgetCard/>}
            {
                !finCheckContext.widget &&
                <>
                    {finCheckContext.isReported && <Result isError={false} message={finCheckContext.message}/>}
                    {
                        finCheckContext.process && finCheckContext.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.FINAL &&
                        <Result title={'موفق'} message={finCheckContext.message} isError={false}/>
                    }
                    {
                        finCheckContext.process && finCheckContext.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.INIT_CONFIRM &&
                        <InitConfirm onConfirm={finCheckContext.handleInitConfirm}/>
                    }
                    {
                        finCheckContext.process && finCheckContext.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.CREATE_PAYMENT &&
                        <CreatePayment/>
                    }

                    {
                        finCheckContext.process && finCheckContext.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.PAYMENT_INQUIRY &&
                        <CreatePayment/>
                    }

                    {
                        finCheckContext.process && finCheckContext.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.BANKING_OTP_VERIFY &&
                        finCheckContext.showOTP  &&
                        <OTP key={finCheckContext.process.otp_time} title={OTP_CONFIG.TITLE}
                             timerCount={calculateOtpTimer(finCheckContext.process.otp_time, 120) > 0 ? calculateOtpTimer(finCheckContext.process.otp_time, 120) : 0}
                             handleRequestOTP={() => finCheckContext.handleBankingOTPSend(finCheckContext.pid)}
                             handleConfirm={finCheckContext.handleBankingOTPVerify}
                             error={finCheckContext.otpError}
                             description={`کد اعتبار سنجی برای شماره موبایل ${finCheckContext.process.platform_user} ارسال شده است.`}/>
                    }
                </>
            }

        </Container>
        }

    </>

}
export default FinCheckContent;